export { default } from './MaxTaxExposureDisplayContainer'
